import type { Campaign } from '../../../../types/CoreShoppingExperience';

const isAutoCampaign = (campaign: Campaign | undefined) => campaign?.encryptedCampaignGeneratorSettingsUUID != null;

export default isAutoCampaign;
